import React from 'react';
import { View } from 'react-native';
import { Text } from 'react-native-paper';
import { MoreCircle, TickCircle, CloseCircle } from 'iconsax-react-native';

export default function PropertyVisitCard({ data }){
  const times = {
    0: 'اول',
    1: 'دوم',
    2: 'سوم',
    3: 'چهارم',
    4: 'پنجم',
  }

  console.log(data);

  return (
    <View style={{ flex: 1, backgroundColor: '#fff', elevation: 2, borderRadius: 8, padding: 12, marginBottom: 8 }}>
      <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10 }}>
        {
          data.statusShow === 'تایید شده' ?
            <View style={{ flexDirection: 'row', alignItems: 'center' }}>
              <TickCircle size="24" color="#3C9A4F" variant="Bold"/>
              <Text style={{ fontSize: 12, marginLeft: 8, color: '#3C9A4F' }}>تایید شده</Text>
            </View>
          :
            data.statusShow === 'در حال بررسی!' ?
              <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                <MoreCircle size="24" color="#FFA200" variant="Bold"/>
                <Text style={{ fontSize: 12, marginLeft: 8, color: '#FFA200' }}>در انتظار بررسی!</Text>
              </View>
            :
              <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                <CloseCircle size="24" color="#D61600" variant="Bold"/>
                <Text style={{ fontSize: 12, marginLeft: 8, color: '#D61600' }}>رد شده</Text>
              </View>
        }
      </View>
      <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14 }}>
        <Text style={{ fontSize: 14, color: '#6C6B6A', fontFamily: 'IRANSans_Medium' }}>کد آگهی:</Text>
        <View style={{ borderColor: '#BFC0C5', borderRadius: 4, borderWidth: 1, paddingHorizontal: 16, paddingVertical: 2 }}>
          <Text style={{ color: '#131B22', fontSize: 14, fontFamily: 'IRANSans_Medium' }}>{data.post?.postId}</Text>
        </View>
      </View>
      <View style={{ marginBottom: 11, paddingBottom: 11, borderBottomColor: '#EBEBEB', borderBottomWidth: 1 }}>
        <Text style={{ fontSize: 12, color: '#879CA6', fontFamily: 'IRANSans_Medium' }}>توضیحات:</Text>
        <Text style={{ fontSize: 12, color: '#4D4D4D', marginTop: 4 }}>{data.des}</Text>
      </View>
      <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', marginBottom: 11, paddingBottom: 11, borderBottomColor: '#EBEBEB', borderBottomWidth: 1 }}>
        <Text style={{ fontSize: 12, color: '#879CA6', fontFamily: 'IRANSans_Medium' }}>نام درخواست دهنده:</Text>
        <Text style={{ fontSize: 12, color: '#3F3E3D', marginTop: 4, fontFamily: 'IRANSans_Medium' }}>{data.user?.name}</Text>
      </View>
      <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', marginBottom: 11, paddingBottom: 11, borderBottomColor: '#EBEBEB', borderBottomWidth: 1 }}>
        <Text style={{ fontSize: 12, color: '#879CA6', fontFamily: 'IRANSans_Medium' }}>شماره درخواست دهنده:</Text>
        <Text style={{ fontSize: 12, color: '#3F3E3D', marginTop: 4, fontFamily: 'IRANSans_Medium' }}>{data.user?.mobile}</Text>
      </View>
      {
        Object.keys(data.dateTimes).length > 0 ?
          Object.values(data.dateTimes).map((item, i) => (
            <View key={i} style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', marginBottom: 11, paddingBottom: 11, borderBottomColor: '#EBEBEB', borderBottomWidth: 1 }}>
              <Text style={{ fontSize: 12, color: '#879CA6', fontFamily: 'IRANSans_Medium' }}>زمان بازدید {times[i] ? times[i] : 'سایر'}:</Text>
              <Text style={{ fontSize: 12, color: '#3F3E3D', marginTop: 4, fontFamily: 'IRANSans_Medium' }}>{item.date} - {item.time}</Text>
            </View>
          ))
        :
          <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', marginBottom: 11, paddingBottom: 11, borderBottomColor: '#EBEBEB', borderBottomWidth: 1 }}>
            <Text style={{ fontSize: 12, color: '#879CA6', fontFamily: 'IRANSans_Medium' }}>زمان بازدید:</Text>
            <Text style={{ fontSize: 12, color: '#3F3E3D', marginTop: 4, fontFamily: 'IRANSans_Medium' }}>انتخاب نشده</Text>
          </View>
      }
      <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
        <Text style={{ fontSize: 12, color: '#879CA6', fontFamily: 'IRANSans_Medium' }}>تاریخ ثبت:</Text>
        <Text style={{ fontSize: 12, color: '#3F3E3D', marginTop: 4, fontFamily: 'IRANSans_Medium' }}>{data.timeAgo}</Text>
      </View>
    </View>
  );
};